<script lang="ts">
  import {
    configuration,
    selectedOptions,
    savedConfigurationPhoto,
    sayDuckModelLoading,
    sayDuckPhotoLoading,
    selectedSayDuckOptions
  } from '../store'

  let sayDuckApi
  window.addEventListener('sayduck.api-ready', (event) => {
    sayDuckApi = event.detail.instance
    for (const [key, value] of Object.entries($selectedSayDuckOptions)) {
      sayDuckApi.configurator.setActiveByUuid(value)
    }
  });

  $: if ($selectedOptions) {
    if (sayDuckApi) {
      $sayDuckModelLoading = true
      for (const [key, value] of Object.entries($selectedSayDuckOptions)) {
        if (value) {
          sayDuckApi.configurator.setActiveByUuid(value)
        }
      }
      $sayDuckModelLoading = false
    }
  }

  document.addEventListener(
    'sayduck.editor.gltfLoaded',
    async () => {
      if (sayDuckApi) {
        $sayDuckModelLoading = true
        for (const [key, value] of Object.entries($selectedSayDuckOptions)) {
          if (value) {
            sayDuckApi.configurator.setActiveByUuid(value)
          }
        }
        $sayDuckModelLoading = false
      }
    },
    false
  )

  document.addEventListener(
    'sayduck.configurator.selectedConfigurationUpdated',
    (e: CustomEvent) => {
      // console.log("sayduck.configurator.selectedConfigurationUpdated")
      // $sayDuckModelLoading = false
    },
    false
  )

  document.addEventListener('sayduck.viewer.photoTaken', (e: CustomEvent) => {
    $savedConfigurationPhoto = e.detail.dataUrl
    $sayDuckPhotoLoading = false
  })
</script>

<div  class="sayduck-3d-viewer-wrap">
  <div>
    <sayduck-viewer
            mode="configurator"
            background="#ebebeb"
            theme-primary-colour="rgba(0,0,0,1)"
            hide-photo-studio
            hide-picker
            hide-embed
            hide-loading
            hide-controls-hint
            hide-product-info
            hide-fullscreen
            hide-dimensions
            hide-branding
            product="{$configuration.sayduckProductId}"
    ></sayduck-viewer>
  </div>
  <script src="https://viewer.sayduck.com" type="text/javascript" async></script>
</div>

<style>
  .sayduck-3d-viewer-wrap > div {
    position: absolute;
    /* top: 0; */
    /* min-height: 650px; */
    /* min-width: 500px; */
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 1024px) {
    .sayduck-3d-viewer-wrap > div {
      position: relative;
      /* min-height: 470px; */
      /* min-height: 220px; */
      min-height: calc(50vh - 60px);
    }
  }
</style>
